import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-orgnization-package',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './create-orgnization-package.component.html',
  styleUrl: './create-orgnization-package.component.scss'
})
export class CreateOrgnizationPackageComponent {

  @Input() orgId: string = '';
  @Input() type: string = 'Create';
  @Input() allPackages: any[] = [];

  packageForm!: FormGroup;
  submitted = false;
  isLoading = false;

  statusOptions = ['Active', 'Inactive'];
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() orgDataToEdit: any = null;

  constructor(private fb: FormBuilder,
    private orgService: OrganizationService
  ) { }

  ngOnInit() {
    this.packageForm = this.fb.group({
      package_id: [2, Validators.required],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
      reminder_before_days: [7, [Validators.required, Validators.min(0)]],
      grace_period: [5, [Validators.required, Validators.min(0)]],
      auto_renewal: [true],
      total_user: [50, [Validators.required, Validators.min(1)]],
      status: ['Active', Validators.required]
    });
    console.log(" all pacjages", this.allPackages);
    this.allPackages = this.allPackages.map((pkg: any) =>
      ({ name: pkg.package_name, value: pkg.package_id })
    );

    if (this.type === 'Update' && this.orgDataToEdit) {
      this.packageForm.patchValue({
        package_id: this.orgDataToEdit.package_id,
        start_date: this.orgDataToEdit.start_date,
        end_date: this.orgDataToEdit.end_date,
        reminder_before_days: this.orgDataToEdit.reminder_before_days,
        grace_period: this.orgDataToEdit.grace_period,
        auto_renewal: this.orgDataToEdit.auto_renewal,
        total_user: this.orgDataToEdit.total_user,
        status: this.orgDataToEdit.status
      });

      // start date and end date format
      const startDate = new Date(this.orgDataToEdit.start_date);
      const endDate = new Date(this.orgDataToEdit.end_date);
      this.packageForm.patchValue({
        start_date: startDate,
        end_date: endDate
      });

    }

  }

  submitForm() {
    this.submitted = true;
    if (this.packageForm.invalid) return;

    this.isLoading = true;

    const payload: any = {
      organization_id: this.orgId,
      package_id: this.packageForm.get('package_id')?.value,
      start_date: this.packageForm.get('start_date')?.value,
      end_date: this.packageForm.get('end_date')?.value,
      reminder_before_days: this.packageForm.get('reminder_before_days')?.value,
      grace_period: this.packageForm.get('grace_period')?.value,
      auto_renewal: this.packageForm.get('auto_renewal')?.value,
      total_user: this.packageForm.get('total_user')?.value,
      status: this.packageForm.get('status')?.value
    }


    if (this.type === 'Create') {
      this.orgService.createOrgnizationPackage(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.close.emit();
          this.reload.emit();
        },
        error: (err) => {
          this.isLoading = false;
        }
      });
    } else {
      payload['id'] = this.orgDataToEdit.id;
      this.orgService.updateOrganizationPackage(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.reload.emit();
          this.close.emit();
        },
        error: (err) => {
          this.isLoading = false;
        }
      });
    }

  }


  handleCloseDialog() {
    this.close.emit();
  }

}
